<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon financeiro-icon">
      <i class="pi pi-receipt"></i>
    </div>
    <span class="card-header-title">{{ 'relatorio-contas-a-receber.texts.relatorio_contas_a_receber' | translate }}</span>
  </div>
  <div class="card-content">
    <div class="form-grid">

      <!-- Pessoa -->
      <div class="form-field col-7">
        <label class="form-label">{{ 'relatorio-contas-a-receber.labels.selecionar_pessoa' | translate }}</label>
        <p-dropdown [options]="clientes" [(ngModel)]="selectedCliente" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-contas-a-receber.placeholders.selecione' | translate)"
          (onFilter)="onClientesFilter($event)" [loading]="loadingClientes" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-contas-a-pagar.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-contas-a-pagar.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-contas-a-pagar.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-contas-a-pagar.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-contas-a-pagar.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-contas-a-pagar.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-cliente pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ cliente.codigoPessoa }}</div>
              <div class="col-3">{{ cliente.nome }}</div>
              <div class="col-2">{{ cliente.fantasia }}</div>
              <div class="col-2">{{ cliente.telefone }}</div>
              <div class="col-2">{{ cliente.ci }}</div>
              <div class="col-2">{{ cliente.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-contas-a-pagar.spans.nenhuma_pessoa_encontrada' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Período (componente compartilhado do dashboard) -->
      <div class="form-field col-4">
        <label class="form-label">{{ 'periodos_relatorio.selecione_o_periodo' | translate }}</label>
        <app-periodo-filtro modo="avancado" [valorPadrao]="'showAll'" [persistir]="true" [opcoes]="opcoesPeriodo" [textoExibicao]="periodoTexto"
          styleClass="w-full periodo-filtro-neutro" (periodoChanged)="onPeriodoChanged($event)"></app-periodo-filtro>
      </div>

      <!-- Botão Emitir -->
      <div class="form-field full">
        <div class="actions-container">
          <button pButton type="button" [disabled]="emitindoRelatorio" class="btn-primary"
            label="{{ 'relatorio-contas-a-receber.buttons.emitir_relatorio' | translate }}" icon="pi pi-file-pdf"
            (click)="emitirRelatorio()">
          </button>
          <app-loading-dialog [visible]="emitindoRelatorio"
            title="{{ 'relatorios.texts.gerando_relatorio' | translate }}" />
        </div>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
